import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../config';
import {
  ScreencastSessionDetailApiResponse,
  ScreencastSessionsApiResponse,
  ScreencastSessionsQuery,
} from '../entitlements/screencast-sessions.types';

@Injectable({ providedIn: 'root' })
export class ScreencastSessionsService {
  constructor(private http: HttpClient) {}

  list(query: ScreencastSessionsQuery = {}): Observable<ScreencastSessionsApiResponse> {
    let params = new HttpParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      params = params.set(key, String(value));
    });
    return this.http.get<ScreencastSessionsApiResponse>(
      `${config.baseUrl}supersee/v1/screencast/sessions`,
      { params }
    );
  }

  detail(
    sessionId: string,
    query: Pick<ScreencastSessionsQuery, 'timezone' | 'company_id'> = {}
  ): Observable<ScreencastSessionDetailApiResponse> {
    let params = new HttpParams();
    if (query.timezone) {
      params = params.set('timezone', query.timezone);
    }
    if (query.company_id != null) {
      params = params.set('company_id', String(query.company_id));
    }
    return this.http.get<ScreencastSessionDetailApiResponse>(
      `${config.baseUrl}supersee/v1/screencast/sessions/${encodeURIComponent(sessionId)}`,
      { params }
    );
  }
}
